import { BriefType } from "../../../../constants/types";

import {
  Date,
  Product,
  StatusChip,
  UserName,
  UserNameAvatar,
} from "../../../../components/layout/listing-table/listing-table-render-components";
import {
  renderAvatarList,
  renderAvatarListFromContentCreators,
} from "../../../../components/layout/listing-table/listing-table-render-components/avatar-list/avatar-list.functions";
import { renderExternalLink } from "../../../../components/layout/listing-table/listing-table-render-components/external-link/external-link.functions";
import { TCol } from "../../../../components/layout/listing-table/listing-table.types";

import { ISection } from "./app-search-sections.types";

const ExternalLink: TCol = {
  label: "",
  key: "",
  stopPropagation: true,
  render: (row, link) => renderExternalLink(row, link),
};

export const sections: ISection[] = [
  {
    columns: [],
    // @ts-ignore
    dataKey: "",
    endpoint: "",
    label: "All",
    path: "default_selection_when_no_path_matches",
  },
  {
    columns: [
      { label: "Name", key: "name" },
      { label: "Status", key: "status", render: (row) => StatusChip(row.status) },
      { label: "Owner", key: "briefOwner", render: (row) => UserName(row.briefOwner) },
      { label: "Start Date", key: "startAt", render: (row) => Date(row.startAt) },
      { label: "End Date", key: "endAt", render: (row) => Date(row.endAt) },
      { label: "Approvers", key: "reviewers", render: (row) => renderAvatarList(row.reviewers) },
      ExternalLink,
    ],
    dataKey: "campaignBriefs",
    endpoint: "campaign-briefs-simplified/",
    filterType: BriefType.CAMPAIGN_BRIEF,
    label: "Campaign Briefs",
    link: (row) => `/campaign-brief/${row.id}`,
    path: "/campaign-brief",
  },

  {
    columns: [
      { label: "Name", key: "name" },
      { label: "Status", key: "status", render: (row) => StatusChip(row.status) },
      { label: "Owner", key: "briefOwner", render: (row) => UserName(row.briefOwner) },
      { label: "Created Date", key: "createdAt", render: (row) => Date(row.createdAt) },
      { label: "Approvers", key: "reviewers", render: (row) => renderAvatarList(row.reviewers) },
      ExternalLink,
    ],
    dataKey: "executionBriefs",
    endpoint: "execution-briefs-simplified/",
    filterType: BriefType.EXECUTION_BRIEF,
    label: "Multi Channel Briefs",
    link: (row) => `/multi-channel-brief/${row.id}`,
    path: "/multi-channel-brief",
  },

  {
    columns: [
      { label: "Name", key: "name" },
      { label: "Status", key: "status", render: (row) => StatusChip(row.status) },
      {
        label: "Owner",
        key: "ownerName",
      },
      {
        label: "Assignee",
        key: "contentCreators",
        render: (row) => renderAvatarListFromContentCreators(row.contentCreators, "Unassigned"),
      },
      { label: "Creative Due Date", key: "dueAt", render: (row) => Date(row.dueAt) },
      { label: "Approvers", key: "reviewers", render: (row) => renderAvatarList(row.reviewers) },
      ExternalLink,
    ],
    dataKey: "workOrders",
    endpoint: "work-orders-simplified/",
    filterType: BriefType.WORK_ORDER,
    label: "Work Orders",
    link: (row) => `/work-order/${row.id}`,
    path: "/work-order",
  },

  {
    columns: [
      { label: "Name", key: "name" },
      { label: "Owner", key: "owner", render: (row) => UserName(row.owner) },
      { label: "Start Date", key: "startAt", render: (row) => Date(row.startAt) },
      { label: "End Date", key: "endAt", render: (row) => Date(row.endAt) },
      ExternalLink,
    ],
    dataKey: "flyers",
    endpoint: "flyers/",
    label: "Design Layouts",
    link: (row) => `/design-layouts/${row.id}`,
    path: "/design-layouts",
  },

  {
    columns: [
      { label: "Name", key: "name", render: UserNameAvatar },
      { label: "Email", key: "email" },
    ],
    dataKey: "users",
    endpoint: "users-simplified/",
    label: "Users",
    path: "/users",
  },

  {
    columns: [
      { label: "", key: "image", render: Product },
      { label: "Item Code", key: "sku" },
      { label: "Item Description", key: "name" },
      { label: "SubClass", key: "subcategory" },
      { label: "Reg. Price", key: "price" },
    ],
    dataKey: "products",
    endpoint: "products-simplified/",
    label: "Products",
    path: "/products",
  },
];
